<template>
  <page-container title="Clients">
    <v-card elevation="0" min-width="100%" class="my-4">
      <common-data-table
        title="Clients"
        newActionTitle="New client"
        :headers="headers"
        collectionName="clients"
        @click:row="rowClicked"
      >
        <template v-slot:newItemPopup="{ close, item, formKey }">
          <common-editing-popup
            :title="item ? 'Edit client' : 'New client'"
            @close="close()"
            :canSubmit="formValid"
            collectionName="clients"
            :originalItem="item"
            :key="'client-edit-' + (item ? item.id : formKey)"
          >
            <template v-slot:default="{ editedItem }">
              <v-form v-model="formValid" ref="form">
                <v-container class="pa-0">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Company name"
                        v-model="editedItem.company_name"
                        :rules="[rules.required]"
                      ></v-text-field>
                      <v-text-field
                        label="Address Line 1"
                        v-model="editedItem.address_line_1"
                      ></v-text-field>
                      <v-text-field
                        label="Address Line 2"
                        v-model="editedItem.address_line_2"
                      ></v-text-field>
                      <v-text-field
                        label="Town / City"
                        v-model="editedItem.city"
                      ></v-text-field>
                      <v-text-field
                        label="Postcode"
                        v-model="editedItem.postcode"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
          </common-editing-popup>
        </template>
      </common-data-table>
    </v-card>
  </page-container>
</template>

<script>
import CommonDataTable from '@/components/CommonDataTable.vue'
import CommonEditingPopup from '@/components/CommonEditingPopup.vue'
import PageContainer from '@/components/PageContainer.vue'
import { textFieldRules } from '@/common'

export default {
  name: 'Clients',
  components: {
    PageContainer,
    CommonDataTable,
    CommonEditingPopup,
  },
  data() {
    return {
      rules: textFieldRules,
      formValid: false,
      headers: [
        {
          text: 'Company name',
          value: 'company_name',
        },
        {
          text: 'Active projects',
          value: 'active_projects_count',
        },
      ],
    }
  },
  methods: {
    rowClicked(data) {
      this.$router.push({
        name: 'client-details',
        params: { id: data.id, title: data.company_name },
      })
    },
  },
}
</script>
